import script from "./ClassifierEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassifierEditor.vue?vue&type=script&setup=true&lang=js"

import "./ClassifierEditor.vue?vue&type=style&index=0&id=5131d309&lang=scss"

const __exports__ = script;

export default __exports__